// extracted by mini-css-extract-plugin
export default {"root":"BarChart_root__CmglC","labelName":"BarChart_labelName__Qwnvo","right":"BarChart_right__PBvTg"};